import { ResponseWrapper } from '@/api/types/base.types'
import type { AxiosResponse, AxiosRequestConfig } from 'axios'
import { getTaskTrackerCurrentUserErrorMessage } from '../lib/taskTrackerCurrentUserError.utils'

export const TASK_TRACKER_API_REQUEST_CONFIG = {
  skipGlobalErrorAlert: true,
} as AxiosRequestConfig & { skipGlobalErrorAlert: boolean }

type TaskTrackerApiErrorSource = unknown

const getTaskTrackerApiErrorData = (
  response: TaskTrackerApiErrorSource,
): ResponseWrapper<unknown> | undefined => {
  const source = response as
    | ResponseWrapper<unknown>
    | AxiosResponse<ResponseWrapper<unknown>>
    | { response?: { data?: ResponseWrapper<unknown> } }
    | undefined

  if (source && 'response' in source && source.response?.data) {
    return source.response.data
  }

  if (source && 'data' in source && source.data) {
    return source.data as ResponseWrapper<unknown>
  }

  return source as ResponseWrapper<unknown> | undefined
}

export const getApiErrorMessage = (
  response: TaskTrackerApiErrorSource,
  fallback: string,
) => {
  const data = getTaskTrackerApiErrorData(response)

  if (data?.status !== 'error') return fallback
  const raw = data.error
  if (Array.isArray(raw)) {
    return getTaskTrackerCurrentUserErrorMessage(raw.map(String).join(' '))
  }
  if (typeof raw === 'string' && raw.trim()) {
    return getTaskTrackerCurrentUserErrorMessage(raw.trim())
  }
  return fallback
}
